import { supabase } from '@/lib/supabase';
import { Language } from '@/shared/types/language';

export const updateLanguage = async (profileId: string, language: Language) => {
  const { error } = await supabase
    .from('profiles')
    .update({ language })
    .eq('id', profileId);

  if (error) throw error;
};
